import {InjectIntl} from "@irati/utils/lang"

const MAX_NUMBER_OF_RECIPIENTS = "PBRewardPointsAppBatchLimitExceeded"
const ErrorsIntlMap = {
  [MAX_NUMBER_OF_RECIPIENTS]: "platform.recipients.list.maxRecipientsMsg"
}
export const parseRewardError = (intl: InjectIntl, error: string) => {
  return ErrorsIntlMap[error] ? intl.formatMessage({id: ErrorsIntlMap[error]}) : error
}
